module.exports = __webpack_public_path__ + "img/hygiene.739fc0ee.svg";